import { render, staticRenderFns } from "./SectionBoxYesNo.vue?vue&type=template&id=58587883&scoped=true"
import script from "./SectionBoxYesNo.vue?vue&type=script&lang=js"
export * from "./SectionBoxYesNo.vue?vue&type=script&lang=js"
import style0 from "./SectionBoxYesNo.vue?vue&type=style&index=0&id=58587883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58587883",
  null
  
)

export default component.exports